<template>
  <div>
    <div class="md-layout" style="height: 800px" v-if="iframeUrl">
      <iframe
        :src="iframeUrl"
        frameborder="0"
        width="100%"
        height="100%"
        allowtransparency>
      </iframe>
    </div>
    <div v-if="!iframeUrl && !showError">
      <md-empty-state
        md-icon="hourglass_empty"
        md-label="Loading"
        md-description="Please wait whilst the report is loading."
      />
    </div>
    <div v-if="showError">
      <md-empty-state
        md-icon="close"
        md-label="Failed to retrieve report"
        md-description="Please refresh the page."
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeUrl: null,
      showError: false,
    }
  },
  methods: {
    async getIframeUrl () {
      try {
        const response = await axios.get('/api/v1/reporting/getBrokerAuctionUrl');
        this.iframeUrl = response.data;
      } catch (error) {
        this.showError = true;
        console.log(error);
      }
    }
  },
  created() {
    this.getIframeUrl();
  },
}
</script>